import { ErrorCode } from '@/Types/Enums/errorCode';
import { UpdateUserRequest } from '@/Types/requestModels/updateUserRequest';
import { User } from '@/Types/user';
import apiClient from '@/Services/Clients/apiClient';

const CURRENT_USER_BASE_URL: string = 'api/CurrentUser';
export default class CurrentUserService {

  /**
   * @param {ErrorCode[]} wellknownErrorCodes Well-known error codes that if returned should not be logged
   * @return {Promise<unknown>}
   */
  public static getUserData(wellknownErrorCodes: ErrorCode[]): Promise<User> {
    return apiClient.get(CURRENT_USER_BASE_URL, wellknownErrorCodes);
  }

  public static updateUserData(userData: UpdateUserRequest): Promise<User> {
    return apiClient.put(CURRENT_USER_BASE_URL, userData);
  }

  public static updateLanguageCode(languageCode: string): Promise<User> {
    console.debug(`Saving the language code '${languageCode}' for the user`);

    const resourceUrl = `${CURRENT_USER_BASE_URL}/languageCode`;
    return apiClient.put(resourceUrl, languageCode);
  }
}